import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import React from "react";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import { withStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import clsx from "clsx";
import appConstants from "../../../../../../../appConstants";
import CloseIcon from "@material-ui/icons/Close";
import Form from "./Form";
import ShipmentDetails from "../../common/ShipmentDetails";
import { compose } from "recompose";
import { withFeatureFlags } from "../../../../../../../userProfile/featureFlagsContext";

const styles = (theme) => ({
  card: {
    marginBottom: 4,
    overflow: "inherit",
    backgroundColor: theme.ModalBGColor,
  },
  title: {
    color: theme.ModalHeaderTextColor,
    fontSize: 10,
  },
  subheader: {
    color: theme.ToggleIconColor,
    fontSize: theme.textFontSize,
  },
  closeIcon: {
    color: theme.iconColor,
  },
  headerRoot: {
    padding: 8,
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
  },
  editIcon: {
    marginTop: 8,
  },
  proContentContainer: {
    padding: 8,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  expandedCardView: {
    display: "flex",
    justifyContent: "flex-end",
    height: 26,
    margin: "0 -8 -8 -8",
  },
  pendingStatusBG: {
    backgroundColor: theme.stopsStatusBGColor,
    opacity: 0.9,
    color: theme.iconColor,
  },
  errorStatusBG: {
    backgroundColor: theme.errorBGColor,
    opacity: 0.9,
    color: theme.errorTextColor,
  },
  successStatusBG: {
    backgroundColor: theme.HighlightColor,
    opacity: 0.9,
    color: theme.successTextColor,
  },
  shipperName: { color: theme.iconColor, fontSize: 20 },
  shipperAddress: { color: theme.iconColor, fontSize: theme.textFontSize },
  delStatus: {
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: 2.5,
    marginRight: 8,
    textTransform: "uppercase",
  },
});

class ShipmentCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      isEditButtonClicked: false,
      proToBeEdited: null,
    };
    this.enableCheckDigit = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableCheckDigit
    );
  }

  handleEditClick = () => {
    this.setState({ expanded: true });
  };
  handleCloseClick = () => {
    this.setState({ expanded: false });
  };

  getDeliveryStatusText = () => {
    const { deliveryStatusList, deliveryStatus } = this.props;
    const delStatusLabel = deliveryStatusList.find(
      (item) => item.value === deliveryStatus.deliveryStatus
    )?.labelText;
    return delStatusLabel
      ? delStatusLabel
      : appConstants.DELIVERY_STOP_PRO_PENDING_STATUS;
  };

  getDeliveryStatusClassName = (deliveryStatusLabel) => {
    const { deliveryStatus, classes } = this.props;
    if (deliveryStatus.hasError) {
      return classes.errorStatusBG;
    } else {
      return deliveryStatusLabel !==
        appConstants.DELIVERY_STOP_PRO_PENDING_STATUS
        ? classes.successStatusBG
        : classes.pendingStatusBG;
    }
  };
  render() {
    const {
      classes,
      shipmentData,
      deliveryStatus,
      forwardRef,
      handleChange,
      freightBillDetails,
      ...other
    } = this.props;
    const delStatusLabel = this.getDeliveryStatusText();
    return (
      <Card className={classes.card}>
        <CardHeader
          classes={{
            title: classes.title,
            subheader: classes.subheader,
            root: classes.headerRoot,
          }}
          action={
            !this.state.expanded ? (
              <IconButton
                aria-label="edit"
                className={`${clsx(classes.expand, {
                  [classes.expandOpen]: this.state.expanded,
                })} ${classes.editIcon}`}
                onClick={this.handleEditClick}
                aria-expanded={this.state.expanded}
              >
                <EditIcon className={classes.closeIcon} />
              </IconButton>
            ) : (
              <IconButton
                aria-label="close"
                className={`${clsx(classes.expand, {
                  [classes.expandOpen]: this.state.expanded,
                })} ${classes.editIcon}`}
                onClick={this.handleCloseClick}
                aria-expanded={this.state.expanded}
              >
                <CloseIcon className={classes.closeIcon} />
              </IconButton>
            )
          }
          subheader={`PRO# ${
            this.enableCheckDigit
              ? shipmentData.checkDigitPro
              : shipmentData.proId
          }`}
        />
        <CardContent classes={{ root: classes.proContentContainer }}>
          <div>
            <div className={classes.shipperName}>
              {shipmentData.shipperName}
            </div>
            <div className={classes.shipperAddress}>
              {shipmentData.shipperAddress}
            </div>
          </div>
          {!this.state.expanded && (
            <div
              className={`${
                classes.expandedCardView
              } ${this.getDeliveryStatusClassName(delStatusLabel)}`}
            >
              <span
                className={`${
                  classes.delStatus
                } ${this.getDeliveryStatusClassName(delStatusLabel)}`}
              >
                delivery status: {delStatusLabel}
              </span>
            </div>
          )}
        </CardContent>
        <Collapse in={this.state.expanded} timeout="auto">
          <CardContent>
            <ShipmentDetails
              shipmentData={shipmentData}
              freightBillDetails={freightBillDetails}
            />
            <Form
              forwardRef={forwardRef}
              shipmentData={shipmentData}
              deliveryStatus={deliveryStatus.deliveryStatus}
              handleChange={handleChange(shipmentData.proId)}
              {...other}
            />
          </CardContent>
        </Collapse>
      </Card>
    );
  }
}

export default compose(withStyles(styles), withFeatureFlags)(ShipmentCard);